const API_BASE = process.env.REACT_APP_WORDPRESS_URL
  ? `${process.env.REACT_APP_WORDPRESS_URL}/wp-json`
  : 'http://localhost:8080/wp-json';

export const fetchSlideBySlug = async (slideSlug) => {
  try {
    const response = await fetch(`${API_BASE}/wp/v2/slides?slug=${slideSlug}`);
    if (!response.ok)
      throw new Error(`Failed to fetch slide: ${response.status}`);

    const slides = await response.json();

    if (slides.length > 0) {
      return slides[0];
    } else {
      return null;
    }
  } catch (error) {
    throw error;
  }
};

export const fetchSlideByNumber = async (slideNumber) => {
  try {
    const response = await fetch(`${API_BASE}/wp/v2/slides?per_page=100`);
    if (!response.ok)
      throw new Error(`Failed to fetch slides: ${response.status}`);

    const slides = await response.json();

    const slide = slides.find((slide) => {
      const slideNum = slide.acf?.slide_number;
      const slugMatch = slide.slug === `slide-${slideNumber}`;
      return slideNum == slideNumber || slugMatch;
    });

    return slide || null;
  } catch (error) {
    throw error;
  }
};

export const fetchSlidesByType = async (slideType) => {
  const typeToSlugMap = {
    intro: 'slide-1',
    patch_selection: 'slide-2',
    question: 'slide-3'
  };

  const slug = typeToSlugMap[slideType];
  if (slug) {
    const slide = await fetchSlideBySlug(slug);
    return slide ? [slide] : [];
  }

  try {
    const response = await fetch(`${API_BASE}/wp/v2/slides?per_page=100`);
    if (!response.ok)
      throw new Error(`Failed to fetch slides: ${response.status}`);

    const slides = await response.json();
    return slides.filter((slide) => slide.acf?.slide_type === slideType);
  } catch (error) {
    throw error;
  }
};

export const processACFData = (slide) => {
  if (!slide) {
    return null;
  }

  const acfData = slide.acf || {};

  const processed = {
    id: slide.id,
    title: slide.title?.rendered,
    content: slide.content?.rendered,
    acf: acfData,
    slideType: acfData.slide_type,
    slideTitle:
      acfData.slide_1_intro_title ||
      acfData.slide_title ||
      slide.title?.rendered,
    slideDescription:
      acfData.slide_1_description ||
      acfData.slide_description ||
      'Default Description',
    features: acfData.slide_features || acfData.features || [],
    buttonText: acfData.button_text || 'Continue',
    questionId: acfData.question_id,
    questionTitle: acfData.question_title,
    questionDescription: acfData.question_description,
    answerOptions: acfData.answer_options || [],
    patchSelectTitle: acfData.patch_select_title,
    patchSelectDescription: acfData.patch_select_description,
    patchSelector: acfData.patch_selector || []
  };

  return processed;
};
